import { ReactComponent as Close } from "assets/morning/icon/close.svg";
import Tracking1 from "assets/morning/tracking1.png";
import Tracking2 from "assets/morning/tracking2.png";
import Tracking4 from "assets/morning/tracking4.png";
import { useEffect, useState } from "react";
import Label1 from "assets/morning/label1.png";
import Label2 from "assets/morning/label2.png";
import Label3 from "assets/morning/label3.png";
import PrintDes from "assets/morning/PrintDes.png";
import { TrackingRequest, usePostTrackingPopPrint } from "../../../../hooks/morning/usePostTrackingPopPrint";
import PrintA4 from "./PrintA4";
import PrintColor from "./PrintColor";
// import Spinner from "components/Spinner";

const trackingList = [
    {
        img: Tracking1,
        title: "A4 출력",
        desc: "출력시 눈, 비에 젖지 않게 포장 바랍니다.",
    },
    {
        img: Tracking1,
        title: "A4 인쇄",
        desc: "출력시 눈, 비에 젖지 않게 포장 바랍니다.",
    },
    {
        img: Tracking4,
        title: "컬러 라벨프린터",
        desc: "전용 프린터와 전용 라벨지가 필요합니다.",
    },
];
const Card = ({ img, title, desc, onClick }: { img: string; title: string; desc: string; onClick: () => void }) => (
    <div
        className="group border-[2px] w-full cursor-pointer border-[#e1e2e4] rounded-lg py-8 transition flex flex-col items-center justify-center hover:border-new hover:shadow-md"
        onClick={onClick}
    >
        {title === "A4 인쇄" ? (
            <div className="flex gap-4 items-center justify-center">
                <img src={Tracking1} alt="A4 인쇄" />
                <img src={Tracking2} alt="A4 인쇄" />
            </div>
        ) : (
            <img src={img} alt={title} />
        )}

        <p className="text-[#1b1c1e] mt-5 mb-0.5 text-[22px] font-[500] group-hover:text-new">{title}</p>
        <p className="text-sm font-[500] text-[#5a5c63]">{desc}</p>
    </div>
);

const PrintTracking = ({
    onClose,
    bl_no,
    filter,
    isAllPrint,
}: {
    onClose: () => void;
    bl_no?: string[];
    filter?: TrackingRequest;
    isAllPrint?: boolean;
}) => {
    const [selectedCard, setSelectedCard] = useState<number | null>(null);
    const [labelPosition, setLabelPosition] = useState<number | null>(null);
    const [printA4Pop, setPrintA4Pop] = useState<boolean>(false);
    const [printBlackPop, setPrintBlackPop] = useState<boolean>(false);
    const [printColorPop, setPrintColorPop] = useState<boolean>(false);
    const [printData, setPrintData] = useState<any>(null);

    const { mutate, isPending } = usePostTrackingPopPrint();

    useEffect(() => {
        document.body.classList.add("modal-open");

        return () => {
            document.body.classList.remove("modal-open");
        };
    }, []);

    const getPayload = (extra: Partial<TrackingRequest> = {}): TrackingRequest => {
        if (!isAllPrint) {
            return {
                chk_bl_no: bl_no ?? [],
                ...extra,
            } as TrackingRequest;
        }

        const { chk_bl_no, ...rest } = {
            ...filter,
            ...extra,
        };
        return rest as TrackingRequest;
    };

    const handleCardClick = (index: number) => {
        // 모든 팝업 상태 초기화
        setPrintA4Pop(false);
        setPrintBlackPop(false);
        setPrintColorPop(false);

        if (index === 1) {
            // A4 라벨지는 위치 선택 필요 → API 호출 X
            setSelectedCard(index);
            setLabelPosition(null);
        } else if (index === 0) {
            // 일반 A4 출력
            mutate(getPayload(), {
                onSuccess: data => {
                    setPrintData(data);
                    setPrintA4Pop(true);
                },
            });
        } else if (index === 2) {
            // 컬러 라벨 프린터
            setSelectedCard(index);
        }
    };

    if (selectedCard === 1) {
        return (
            <div className="bg-white w-full max-w-[680px] relative rounded-xl shadow-xl overflow-hidden">
                <div className="flex items-center justify-between px-10 pt-6 pb-5">
                    <p className="text-2xl font-bold">A4 인쇄</p>
                    <Close
                        className="cursor-pointer"
                        onClick={() => {
                            setSelectedCard(null);
                            setPrintA4Pop(false);
                            setPrintBlackPop(false);
                            setPrintColorPop(false);
                            setLabelPosition(null);
                        }}
                    />
                </div>
                <hr />
                <div className="flex flex-col items-center px-10 pb-10 text-center">
                    <p className="text-[#5A5C63] text-lg mt-5">출력 위치 선택 후 인쇄 버튼을 눌러 주세요.</p>
                    <div className="flex w-full gap-4 mt-5">
                        {[1, 2, 3].map(pos => (
                            <div
                                key={pos}
                                onClick={() => setLabelPosition(pos)}
                                className={`group border-[2px] w-full cursor-pointer rounded-lg py-5 transition flex flex-col items-center justify-center ${
                                    labelPosition === pos ? "border-new shadow-md" : "border-[#e1e2e4]"
                                }`}
                            >
                                <img src={pos === 1 ? Label1 : pos === 2 ? Label2 : Label3} alt={`Label${pos}`} />
                                <p className="text-[#1b1c1e] text-[22px] mt-2 font-[500]">{pos}번부터</p>
                            </div>
                        ))}
                    </div>
                </div>
                <button
                    onClick={() => {
                        if (labelPosition !== null) {
                            mutate(
                                {
                                    print_number: labelPosition,
                                    chk_bl_no: bl_no,
                                },
                                {
                                    onSuccess: data => {
                                        setPrintData(data);
                                        setPrintA4Pop(true);
                                        setPrintBlackPop(false);
                                        setPrintColorPop(false);
                                    },
                                },
                            );
                        }
                    }}
                    className=" w-full bg-[#132e47] text-xl font-bold py-[15px] text-white"
                >
                    인쇄
                </button>
                {printA4Pop && (
                    <PrintA4
                        data={printData}
                        onClose={() => {
                            setPrintA4Pop(false);
                            setSelectedCard(null);
                            onClose();
                        }}
                    />
                )}
            </div>
        );
    }
    if (selectedCard === 2) {
        return (
            <div className="bg-white w-full flex flex-col items-center max-w-[1200px] relative rounded-xl shadow-xl overflow-hidden">
                <div className="flex items-center justify-between px-10 pt-6 pb-5 w-full">
                    <p className="text-2xl font-bold">출력 전 "꼭" 설정값을 확인해주세요!</p>
                    <Close className="cursor-pointer" onClick={() => setSelectedCard(null)} />
                </div>
                <img src={PrintDes} alt="PrintDes" className="my-5" />
                <button
                    onClick={() => {
                        mutate(
                            {
                                chk_bl_no: bl_no,
                            },
                            {
                                onSuccess: data => {
                                    setPrintData(data);
                                    setPrintColorPop(true);
                                    setPrintA4Pop(false);
                                    setPrintBlackPop(false);
                                },
                            },
                        );
                    }}
                    className="w-full bg-new text-xl font-bold py-[15px] text-white"
                >
                    확인
                </button>
                {/* {printColorPop && <PrintColor data={printData} onClose={() => setPrintColorPop(false)} />} */}
                {printColorPop && (
                    <PrintColor
                        data={printData}
                        onClose={() => {
                            setPrintColorPop(false);
                            setSelectedCard(null);
                            onClose();
                        }}
                    />
                )}
            </div>
        );
    }
    return (
        <div className="bg-white w-full max-w-[900px] relative rounded-xl shadow-xl overflow-hidden">
            <div className="flex items-center justify-between px-10 pt-6 pb-5">
                <p className="text-2xl font-bold">운송장 출력</p>
                <Close className="cursor-pointer" onClick={onClose} />
            </div>
            <div className="flex flex-col gap-4 px-10 pb-11 pt-2 w-full">
                <div className="flex gap-4 w-full">
                    {/* <Card {...trackingList[0]} onClick={() => handleCardClick(0)} /> */}
                    <Card {...trackingList[1]} onClick={() => handleCardClick(1)} />
                    <Card {...trackingList[2]} onClick={() => handleCardClick(2)} />
                </div>
            </div>
            {printA4Pop && (
                <PrintA4
                    data={printData}
                    onClose={() => {
                        setPrintA4Pop(false);
                        setSelectedCard(null);
                        onClose();
                    }}
                />
            )}
        </div>
    );
};

export default PrintTracking;
